import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import "../css/privacy.scss";

const questions = [
  ["What currency are prices shown in?", "All prices, charges and totals are displayed in pounds sterling (GBP). Every pair in the collection costs between £170 and £220."],
  ["How do I choose my size?", "Check the available sizes and fit guidance on each product page. If you are between sizes, contact us before ordering."],
  ["When will my order be dispatched?", "Confirmed orders are normally prepared within 1 to 3 business days. Transit time then depends on the destination."],
  ["Can I return a pair?", "You may request a return within 14 days of receipt. The pair must be new, unworn outdoors and kept in its original packaging."],
  ["How can I track my order?", "Your dispatch confirmation email includes tracking information when it is available."],
  ["Does the site use advertising cookies?", "No. This version of the site includes no advertising trackers. The cart and wishlist only use your browser's local storage."],
  ["Who operates tastevani?", `${siteConfig.companyName} operates the store from ${siteConfig.address}.`],
  ["How can I manage my privacy choices?", "You can clear the cart and wishlist from your browser settings. See the Privacy Policy and Cookie Policy for information about requests and data handling."],
  ["How can I contact customer service?", `Email ${siteConfig.email}. Please include your order number when asking about an existing purchase.`],
];

function Faqs() {
  useEffect(() => { document.title = `FAQ — ${siteConfig.brandName}`; }, []);
  return (
    <main className="legal-page privacy">
      <header className="legal-header shell">
        <p className="eyebrow">Help Centre</p>
        <h1>Frequently Asked Questions</h1>
        <p>Essential answers about our footwear, pricing, delivery and returns.</p>
      </header>
      <div className="legal-layout shell">
        <nav className="legal-toc" aria-label="On this page"><strong>Topics</strong>{questions.map(([question], index) => <a key={question} href={`#faq-${index + 1}`}>{question}</a>)}</nav>
        <div className="legal-content">
          {questions.map(([question, answer], index) => <section id={`faq-${index + 1}`} key={question}><h2>{question}</h2><p>{answer}</p></section>)}
          <section><h2>Still need help?</h2><p>Use our <Link to="/contact">contact form</Link> or email <a href={`mailto:${siteConfig.email}`}>{siteConfig.email}</a>.</p></section>
        </div>
      </div>
    </main>
  );
}

export default Faqs;
